import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8b9c3906"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column gap-2" }
const _hoisted_2 = { class: "d-flex flex-column gap-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "Nome", -1))
const _hoisted_4 = { class: "d-flex flex-column gap-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "email", -1))
const _hoisted_6 = { class: "d-flex flex-column gap-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "Região", -1))
const _hoisted_8 = { class: "d-flex flex-column gap-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "Cargo", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_FilterBase = _resolveComponent("FilterBase")!

  return (_openBlock(), _createBlock(_component_FilterBase, {
    id: "userIpirangaFilter",
    subtitle: "Faça filtros e aprimore sua busca",
    hideFilter: false,
    staticModal: false,
    hideClose: false,
    activeModal: false,
    closeModal: _ctx.closeModal,
    disabledClick: true,
    onSearch: _ctx.enviarEmit
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_el_input, {
            clearable: "",
            placeholder: "Digite...",
            modelValue: _ctx.usuarioIpirangaFilter.nome,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.usuarioIpirangaFilter.nome) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_el_input, {
            clearable: "",
            placeholder: "Digite...",
            modelValue: _ctx.usuarioIpirangaFilter.email,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.usuarioIpirangaFilter.email) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_el_select, {
            filterable: "",
            placeholder: "Selecione...",
            clearable: "",
            modelValue: _ctx.usuarioIpirangaFilter.regiao,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.usuarioIpirangaFilter.regiao) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayRegioes, (regiao, key) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: key,
                  label: regiao,
                  value: regiao
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_el_select, {
            clearable: "",
            placeholder: "Selecione...",
            modelValue: _ctx.usuarioIpirangaFilter.cargo,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.usuarioIpirangaFilter.cargo) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayCargos, (cargo, key) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: key,
                  label: cargo,
                  value: cargo
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["closeModal", "onSearch"]))
}